const state = () => ({
  allData: [],
  dataDetail: [],
  totalData: 0,
  loading: false,
  cacheData: {},
  errors: [],
  flashErrorMessage: '',
  flashError: false,
  item: null,
  insertProgress: 0,
  downloadFailedURL: '',
  countDone: 0,
  countSame: 0,
  intervalExport: null,
  exportId: null,
  countDataExport: 0,
  totalPage: 0,
  requestData: null,
  refundStatus: false,
  countSameRefund: 0,
  countDoneRefund: 0,
  refundId: null,
  countDataRefund: 0,
  intervalRefund : null,
});

export default state;
